/**
 * Splits `summeryofpayments` into Plan / Vehicle columns.
 *
 * Supported formats:
 * - Booking Payment for VehicleName - PlanName
 * - Renewal Payment for VehicleName - PlanName
 * - Payment for PlanName - VehicleName (legacy)
 */

export function parsePaymentSummaryForPlanVehicle(summaryText: string): {
  plan: string;
  vehicle: string;
} {
  if (!summaryText || summaryText.trim() === "") {
    return { plan: "", vehicle: "" };
  }

  const trimmed = summaryText.trim();

  // Booking Payment for VehicleName - PlanName
  // Renewal Payment for VehicleName - PlanName
  const newFormatRegex = /^(Booking|Renewal)\s+Payment\s+for\s+/i;

  if (newFormatRegex.test(trimmed)) {
    const rest = trimmed.replace(newFormatRegex, "").trim();

    const parts = rest
      .split(" - ")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);

    if (parts.length >= 2) {
      const vehicle = parts[0];
      const plan = parts.slice(1).join(" - ");

      return { plan, vehicle };
    }

    return { plan: "", vehicle: rest };
  }

  // Legacy format
  // Payment for PlanName - VehicleName
  const legacyRegex = /^Payment\s+for\s+/i;

  if (legacyRegex.test(trimmed)) {
    const rest = trimmed.replace(legacyRegex, "").trim();

    const parts = rest
      .split(" - ")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);

    if (parts.length >= 2) {
      const plan = parts[0];
      const vehicle = parts.slice(1).join(" - ");

      return { plan, vehicle };
    }

    return { plan: rest, vehicle: "" };
  }

  return { plan: "", vehicle: "" };
}
